import { render } from "./PanelTipsterKpis.vue?vue&type=template&id=26802f70&scoped=true"
import script from "./PanelTipsterKpis.vue?vue&type=script&lang=js"
export * from "./PanelTipsterKpis.vue?vue&type=script&lang=js"

import "./PanelTipsterKpis.vue?vue&type=style&index=0&id=26802f70&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26802f70"]])

export default __exports__